import api_adm from "./api";
const endpoint = "WebsiteRestController";

export const AssociationService_adm = {
  async getAssociationList(filtre) {
    try {
      const result = await api_adm.get(endpoint + "/list_association", {
        params: filtre,
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  
  async insertSelectedAssociation(data) {
    try {
      const result = await api_adm.post(
        endpoint + "/insertSelectedAssociation",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async deleteSelectedAssociation(data) {
    try {
      const result = await api_adm.post(
        endpoint + "/delete_selected_association",
        data
      );
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
